<div class="modal-street-parking d-flex fd-col gap-16-px" tabindex="0" cdkTrapFocus>
  <div class="street-parking-card busy d-flex" matTooltip="Total plazas disponibles y plazas ocupadas">
    <div class="total-street-spots d-flex fd-col align-items-center justify-content-center">

      <sit-icon [icon]="Icon.places" sizeClass="icon-size-48"></sit-icon>
      <span class="text-color-secondary-2">{{  occupationLines?.totalSpots || properties.totalSpotNumber}}</span>
      <span class="foo-icon">Plazas</span>
    </div>
    <div class="d-flex fd-col justify-content-center">
      <div class="street-parking-status text-color-secondary-2 d-flex align-items-center justify-content-start d-row flex-grow ">
        <span class="available">{{ occupationLines?.spotAvailable || properties.availableSpotNumber}} </span>
        <span>/ </span>
        <span class="used"> {{occupationLines?.spotOccupied || properties.occupiedSpotNumber}}</span>
      </div>
      <span class="subtitle">Plazas disponibles / plazas ocupadas</span>
    </div>
  </div>
  <div class="street-parking-card d-flex" matTooltip="Tiempo máximo de ocupación">
    <div class="total-street-spots d-flex fd-col align-items-center">
      <sit-icon class="icon-card" [icon]="Icon.schedule_y" alt="icono señal tipo zona"
        sizeClass="icon-size-48 icon-res-mod" />
    </div>
    <div
      class="card-status-time text-color-secondary-2 d-flex d-row flex-grow">
      <span >{{properties.maximumParkingDuration ?? '180 minutos.'}}</span>
      <span class="subtitle">Tiempo máximo de ocupación</span>
    </div>
  </div>
</div>
